import styled from 'styled-components';

export const EnterEntityFormWrapper = styled.form`
    display: flex;
    flex-direction: column;
    gap: 24px;
    z-index: 9;
`;
